module.exports = __webpack_public_path__ + "img/SJYG_IOS.177e44d1.png";